// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { HttpMethod, findOperation } from './handlers/utils';
import { delayNextCall, performActionIfRequestd } from './mock.test-helpers';

// for debugging
const globalDelay = localStorage.delay;
if (globalDelay) {
  delayNextCall(/.*/, parseInt(globalDelay), 10000);
}

@Injectable({ providedIn: 'root' })
export class MockAPIService implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    // try to mock this request
    const op = findOperation(req.method as HttpMethod, req.urlWithParams);
    if (op) {
      // if we are mocking this request, invoke handler and
      // return as observable httpresponse, also unpack promises
      const result = (async () => {
        // used to provoke loading states, spinners etc.
        await performActionIfRequestd(req);
        return await op.handler({
          ...op.params,
          body: req.body, // always patching the body on, also for get requests..
        });
      })();
      return (
        result instanceof Promise
          ? from(result).pipe(
              mergeMap((item) => {
                console.log(item);
                return item;
              })
            )
          : result
      ).pipe(
        map(<T>(response: HttpResponse<T>) => {
          // patch response with url for easier debugging
          if ('clone' in response) {
            response = response.clone({ url: req.url });
            console.log(
              '%cMOCKED RESPONSE %c(%s)',
              'text-weight: 600; color: #EE700A;',
              'text-weight: 600; color: #70AA0A;',
              req.method,
              new URL(req.url, 'http://seso').pathname
            );
            console.log('REQUEST', req, 'RESPONSE', response);
            // for wahtever reason we need to throw on errors on our own here
            // thank you angular
            if (!response.ok)
              throw {
                ...response,
                error: response.body, // for WHATEVER reason error is expectd to contain the returned body as well..
              };
          }
          return response;
        })
      );
    }
    return next.handle(req);
  }
}
